import { storeSettings } from "@/stores/settings.js";
import $axios from "@/axios";

export default {
  //請求分類
  get: async function () {
    await $axios
      .post("/api/admin/payment_get.php")
      .then(function (res) {
        if (res.data.result == "pass") {
          storeSettings.payments = res.data.payments;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
};
